import { Component } from 'react';
import './carousel.scss';

/**
 * This component holds all the shared functionality for the carousels
 */
class Carousel extends Component {}

export default Carousel;
